import React, { useState } from "react";
import { MomentDateTime, getValidData } from "../../../Shared/Methods";
import { Tablenodatafound } from "../TableNoDataFount";
import Failureanalysismodal from "../../../Modals/FailureAnalysisModal";
import ShowMoreText from "../../CommonText/ShowMoreText";

interface props {
  Data: any;
  pageSize: number;
  pageind: number;
  OBJHead: string[];
  OBJKeys: string[];
}

function AIReportsTable({ Data, pageSize, pageind, OBJHead, OBJKeys }: props) {
  const { items } = Data;

  const [openmodal, setmodal] = useState({
    isView: false,
    data: "",
    title: "",
  });

  const openModal = (item: any, heading: any) => {
    setmodal({ isView: true, data: item, title: heading });
  };

  const handleCancel = () => {
    setmodal({ isView: false, data: "", title: "" });
  };

  return (
    <>
      {/* <Modal
        open={openmodal.isView}
        closable={!openmodal.isView}
        style={{ width: "100%", maxWidth: "70%" }}
        footer={null}
      >
        <Failureanalysismodal
          data={openmodal?.data}
          onCancel={() => {
            setmodal({ isView: false, data: "", title: "" });
          }}
          heading={openmodal.title}
        />
      </Modal> */}

      {openmodal.isView ? (
        <Failureanalysismodal
          open={openmodal.isView}
          closable={!openmodal.isView}
          data={openmodal?.data}
          onCancel={() => handleCancel()}
          heading={openmodal.title}
        />
      ) : null}
      <tr>
        {OBJHead?.map((ele) => {
          return <th>{ele}</th>;
        })}
      </tr>

      {items && items?.length > 0 ? (
        items?.map((ele: any, ind: number) => {
          return (
            <>
              <tr>
                <td style={{ width: 50 }}>{pageind * pageSize + (ind + 1)}</td>

                {OBJKeys?.map((val, ind) => {
                  return (
                    <>
                      <td
                        key={ind}
                        style={{
                          minWidth: "100px",
                          width:
                            ind === 4
                              ? "300px"
                              : [
                                  "created_at",
                                  "device_name",
                                  "meter_name",
                                ].includes(val)
                              ? "250px"
                              : "",
                        }}
                      >
                        {val === "datetime" || val === "response_time" ? (
                          getValidData(
                            ele[val] ? MomentDateTime(ele[val]) : null
                          )
                        ) : val === "api" ||
                          val === "api_response" ||
                          val === "params" ? (
                          <>
                            <p
                              style={{
                                background: "transparent",
                                padding: "0",
                                width: "100px",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                margin: "auto",
                                height: "61px",
                              }}
                            >
                              {getValidData(ele[val])}
                            </p>
                            {/* {(val === "api" ||
                              val === "api_response" ||
                              val === "params") &&
                            ele[val] &&
                            ele[val].length > 100 ? (
                              <ShowMoreText
                                handleSuccess={() => {
                                  if (val === "api") {
                                    openModal(ele[val], "Api Data");
                                  } else if (val === "api_response") {
                                    openModal(ele[val], "Api Response");
                                  }
                                  if (val === "params") {
                                    openModal(ele[val], "Params Data");
                                  }
                                }}
                                style={{
                                  background: "transparent",
                                  color: "blue",
                                  padding: "0",
                                }}
                              />
                            ) : null} */}
                          </>
                        ) : (
                          getValidData(ele[val])
                        )}
                      </td>
                    </>
                  );
                })}
              </tr>
            </>
          );
        })
      ) : (
        <Tablenodatafound />
      )}
    </>
  );
}

export default AIReportsTable;
